import _extends from '@babel/runtime/helpers/esm/extends';
import React, { forwardRef } from 'react';
import CopyToClipboardRaw from 'react-copy-to-clipboard';

const CopyToClipboardWrapper = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(CopyToClipboardRaw, _extends({}, props, {
    ref: ref
  }));
});
CopyToClipboardWrapper.displayName = 'CopyToClipboardWrapper';
const CopyToClipboard = props => {
  return /*#__PURE__*/React.createElement(CopyToClipboardWrapper, props);
};

export { CopyToClipboard, CopyToClipboardWrapper as default };
